import React from 'react';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Analytics from '../../Components/Analytics';

export default () => {
    return <div className="flex flex-col items-center justify-center h-screen">
        <div className="md:max-w-[400px] max-w-[90%] w-full -mt-[20%]">
            <DialoguesWrapper>
                <HelpWrapper>
                    <ErrorBoundary>
                        <Outlet />
                    </ErrorBoundary>
                </HelpWrapper>
            </DialoguesWrapper>
            <Analytics />
        </div>
    </div>
}
